import React from 'react';

const Step6Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-6">
        Questa informazione è utile per capire l'accessibilità al tuo tetto.
        </div>
    );
}

export default Step6Infos;